var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 189,
    viewBox: "0 0 203 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_659)",
    filter: "url(#filter0_d_16_659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.9277 50.8941C81.8005 49.9786 84.198 46.0969 83.2825 42.2241C82.367 38.3512 78.4853 35.9538 74.6124 36.8692C70.7396 37.7847 68.3421 41.6664 69.2576 45.5393C70.1731 49.4122 74.0548 51.8096 77.9277 50.8941Z",
    fill: "url(#paint0_radial_16_659)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.033 50.9375C131.946 50.2091 134.527 46.4468 133.799 42.5341C133.07 38.6215 129.308 36.0401 125.395 36.7685C121.483 37.4969 118.901 41.2592 119.63 45.1719C120.358 49.0846 124.12 51.6659 128.033 50.9375Z",
    fill: "url(#paint1_radial_16_659)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6198 96.7553C54.1304 94.8766 55.4534 90.5077 53.5746 86.997C51.6959 83.4864 47.327 82.1634 43.8163 84.0421C40.3057 85.9208 38.9827 90.2898 40.8614 93.8004C42.7402 97.3111 47.1091 98.634 50.6198 96.7553Z",
    fill: "url(#paint2_radial_16_659)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7042 143.492C83.2149 141.613 84.5378 137.244 82.6591 133.734C80.7804 130.223 76.4114 128.9 72.9008 130.779C69.3901 132.658 68.0672 137.027 69.9459 140.537C71.8246 144.048 76.1936 145.371 79.7042 143.492Z",
    fill: "url(#paint3_radial_16_659)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.265 142.639C134.342 140.115 134.791 135.575 132.267 132.498C129.743 129.422 125.203 128.973 122.127 131.497C119.05 134.02 118.601 138.56 121.125 141.637C123.648 144.714 128.188 145.162 131.265 142.639Z",
    fill: "url(#paint4_radial_16_659)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_16_659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.5 83.6394C116.36 83.6394 128.406 79.0044 128.406 73.2867C128.406 67.5691 116.36 62.9341 101.5 62.9341C86.6401 62.9341 74.5938 67.5691 74.5938 73.2867C74.5938 79.0044 86.6401 83.6394 101.5 83.6394Z",
    fill: "url(#paint5_linear_16_659)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M90.2625 47.3726H112.737C112.46 46.2581 112.31 45.0935 112.31 43.8944C112.31 42.6051 112.483 41.3556 112.802 40.1655H90.1974C90.5167 41.3556 90.6894 42.6051 90.6894 43.8944C90.6894 45.0935 90.5397 46.2581 90.2625 47.3726V47.3726Z",
    fill: "url(#paint6_radial_16_659)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2571 82.4841L72.6237 57.8387C70.2277 57.2108 68.0754 55.9784 66.3347 54.3176L53.7408 77.5382C55.9805 78.6827 57.883 80.3939 59.2571 82.4841V82.4841Z",
    fill: "url(#paint7_radial_16_659)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1865 98.3857C57.797 100.458 55.8838 102.149 53.6388 103.274L66.3347 126.682C68.0754 125.021 70.2277 123.789 72.6238 123.161L59.1865 98.3857Z",
    fill: "url(#paint8_radial_16_659)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.737 133.627H90.2623C90.5397 134.742 90.6894 135.906 90.6894 137.105C90.6894 138.395 90.5167 139.644 90.1976 140.834H112.802C112.483 139.644 112.31 138.395 112.31 137.105C112.31 135.906 112.46 134.742 112.737 133.627Z",
    fill: "url(#paint9_radial_16_659)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.742 82.4844C145.117 80.3941 147.019 78.6827 149.259 77.5384L136.665 54.3179C134.924 55.9786 132.772 57.2113 130.376 57.839L143.742 82.4844Z",
    fill: "url(#paint10_radial_16_659)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.813 98.3855L130.376 123.161C132.772 123.789 134.924 125.021 136.665 126.682L149.361 103.274C147.116 102.149 145.203 100.458 143.813 98.3855V98.3855Z",
    fill: "url(#paint11_radial_16_659)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.241 96.74C162.752 94.8612 164.075 90.4923 162.196 86.9816C160.317 83.471 155.948 82.148 152.438 84.0267C148.927 85.9055 147.604 90.2744 149.483 93.7851C151.361 97.2957 155.73 98.6187 159.241 96.74Z",
    fill: "url(#paint12_radial_16_659)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_16_659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.5 90.8461C93.4694 90.8461 85.7988 89.5964 79.9015 87.3274C77.8064 86.5214 76.0573 85.6328 74.5938 84.6995V94.3115C75.2664 95.497 77.3456 97.1109 81.0472 98.5353C86.4534 100.615 93.7174 101.761 101.501 101.761C109.181 101.761 116.377 100.641 121.765 98.6076C125.567 97.1724 127.718 95.5184 128.406 94.3127V84.6999C126.943 85.6333 125.194 86.5219 123.099 87.3279C117.201 89.5966 109.531 90.8461 101.5 90.8461V90.8461Z",
    fill: "url(#paint13_linear_16_659)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_16_659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.406 107.713V103.494C127.226 104.137 125.872 104.76 124.31 105.35C118.129 107.683 110.029 108.968 101.501 108.968C91.3967 108.968 81.2197 107.111 74.5938 103.494V107.713C74.5938 110.024 75.7805 114.358 83.7284 117.416C88.5326 119.265 94.8441 120.283 101.5 120.283C108.156 120.283 114.467 119.265 119.272 117.416C127.219 114.358 128.406 110.024 128.406 107.713Z",
    fill: "url(#paint14_linear_16_659)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_16_659",
    x: 0,
    y: -7,
    width: 203,
    height: 203,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16_659"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16_659",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_16_659",
    x: 70.5938,
    y: 62.9341,
    width: 61.8125,
    height: 28.7053,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16_659"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16_659",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_16_659",
    x: 70.5938,
    y: 84.6995,
    width: 61.8127,
    height: 25.0615,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16_659"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16_659",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_16_659",
    x: 70.5938,
    y: 103.494,
    width: 61.8125,
    height: 24.7886,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16_659"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16_659",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_16_659",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(73.9117 38.5888) rotate(76.7004) scale(17.3093)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111111",
    stopOpacity: 0.67
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_16_659",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(124.613 38.4525) rotate(79.4543) scale(17.3106)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111111",
    stopOpacity: 0.67
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_16_659",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.5797 85.8848) rotate(61.8467) scale(17.3186)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111111",
    stopOpacity: 0.67
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_16_659",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.6642 132.622) rotate(61.8467) scale(17.3186)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111111",
    stopOpacity: 0.67
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_16_659",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(122.253 133.349) rotate(50.642) scale(17.308)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111111",
    stopOpacity: 0.67
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_16_659",
    x1: 64.162,
    y1: 62.9638,
    x2: 79.2162,
    y2: 94.3808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBFD5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923907,
    stopColor: "#7FBA00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_16_659",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(99.8097 40.9218) rotate(90) scale(8.65625 27.1503)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111111",
    stopOpacity: 0.67
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_16_659",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.7705 57.2732) rotate(90) scale(33.8303 22.6799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111111",
    stopOpacity: 0.67
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_16_659",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.7119 101.355) rotate(90) scale(33.9867 22.8026)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111111",
    stopOpacity: 0.67
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_16_659",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(99.81 134.383) rotate(90) scale(8.65625 27.1503)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111111",
    stopOpacity: 0.67
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_16_659",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(138.405 57.2735) rotate(90) scale(33.8303 22.6799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111111",
    stopOpacity: 0.67
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_16_659",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(138.449 101.355) rotate(90) scale(33.9867 22.8026)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111111",
    stopOpacity: 0.67
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_16_659",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(152.201 85.8695) rotate(61.8467) scale(17.3186)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111111",
    stopOpacity: 0.67
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_16_659",
    x1: 64.162,
    y1: 84.7239,
    x2: 75.0354,
    y2: 112.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923907,
    stopColor: "#F25123"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_16_659",
    x1: 64.162,
    y1: 103.518,
    x2: 74.7357,
    y2: 130.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923907,
    stopColor: "#02A3F1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 123,
    height: 123,
    fill: "white",
    transform: "translate(40 29)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/Data.8421df3220f4d2f4653940ffd9737772.svg";
export { ForwardRef as ReactComponent };